<script>
    import Button from "@smui/button/Button.svelte";
    import List, { Item, Text, PrimaryText, SecondaryText } from "@smui/list";
    import { onMount } from "svelte";
    import { navigate } from "svelte-routing";
    import Link from "svelte-routing/src/Link.svelte";
    import loading from "../../components/loading";
    import title from "../../components/title";
    import { post } from "../../http";
    import { getObject, setObject } from "../../session";

    export let location;
    let origins = [];

    function next(origin) {
        const pickup = getObject("pickup");

        pickup["pickup_name"] = origin.customer_name;
        pickup["pickup_phone"] = origin.customer_phone;
        pickup["pickup_address"] = origin.address;
        pickup["pickup_city"] = origin.city;
        pickup["pickup_province"] = origin.province;
        pickup["pickup_district"] = origin.district;
        pickup["pickup_zipcode"] = origin.zipcode;
        pickup["origin_code"] = origin.origin_code;

        setObject("pickup", pickup);

        navigate("/pickup/orders");
    }

    onMount(() => {
        loading.show();
        title.set("Alamat Pickup");
        post("/api/address_list")
            .then((resp) => {
                if (resp.status == 0) origins = resp.data;
                // else snackbar.open(resp.message);
            })
            .finally(() => loading.hide());
    });
</script>

<div class="content">
    <div class="caption">
        Pilih alamat pickup atau masukkan
        <Link to="/pickup/address">alamat baru?</Link>
    </div>
    <List class="address" threeLine>
        {#each origins as origin}
            <Item on:SMUI:action={() => next(origin)}>
                <Text>
                    <PrimaryText>{origin.address_name}</PrimaryText>
                    <SecondaryText>{origin.customer_name}</SecondaryText>
                    <SecondaryText>{origin.address}</SecondaryText>
                </Text>
            </Item>
        {/each}
    </List>
</div>
